@if (stateI) {
    <mat-icon aria-label="Status"
        [matTooltip]="stateI !== StatusIndicatorState.None ? 'Status: ' + stateI : ''"
        [ngClass]="'status ' + stateI"
    >
        {{ icon ? icon : Icons.status_checked }}
    </mat-icon>

    <!-- <div [@openClose]="true ? 'open' : 'closed'"></div> -->
}